var _rect, _rect2, _g, _g2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1476,
    height: 401,
    viewBox: "0 0 1476 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1476,
    height: 400,
    rx: 20,
    fill: "url(#paint0_linear_385_6667)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_385_6667",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 1476,
    height: 400
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 1476,
    height: 400,
    rx: 20,
    fill: "url(#paint1_linear_385_6667)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_385_6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.441 62.5999L788.841 52.7599L777.361 -106.32L731.441 62.5999Z",
    fill: "#1865A5",
    stroke: "#1865A5",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.839 52.7599L920.039 -14.4801L777.359 -106.32L788.839 52.7599Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.84 52.76L905.28 88.84L920.04 -14.48L788.84 52.76Z",
    fill: "#3D8DF4",
    stroke: "#3D8DF4",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.48 298.76L905.28 88.84L788.84 52.76L749.48 298.76Z",
    fill: "#17527E",
    stroke: "#17527E",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.359 -106.32L580.559 -142.4L731.439 62.6001L777.359 -106.32Z",
    fill: "#2C80D9",
    stroke: "#2C80D9",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.56 -142.4L533 -106.32L731.44 62.6001L580.56 -142.4Z",
    fill: "#175F98",
    stroke: "#175F98",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.001 -106.32L473.961 44.5599L731.441 62.5999L533.001 -106.32Z",
    fill: "#2073BF",
    stroke: "#2073BF",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.441 62.6L749.481 298.76L788.841 52.76L731.441 62.6Z",
    fill: "#184B72",
    stroke: "#184B72",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 -106.32L272.24 -48.9201L473.96 44.5599L533 -106.32Z",
    fill: "#2679CC",
    stroke: "#2679CC",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.48 288.92L749.48 298.76L731.44 62.6001L585.48 288.92Z",
    fill: "#17527E",
    stroke: "#17527E",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.88 110.16L1143.08 -65.3201L920.039 -14.4801L1134.88 110.16Z",
    fill: "#3486E7",
    stroke: "#3486E7",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.48 298.76L998.76 218.4L905.28 88.8398L749.48 298.76Z",
    fill: "#2C80D9",
    stroke: "#2C80D9",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.961 44.5601L585.481 288.92L731.441 62.6001L473.961 44.5601Z",
    fill: "#2C80D9",
    stroke: "#2C80D9",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.88 110.16L920.041 -14.48L905.281 88.84L1134.88 110.16Z",
    fill: "#175F98",
    stroke: "#175F98",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.761 218.4L1134.88 110.16L905.281 88.8398L998.761 218.4Z",
    fill: "#184B72",
    stroke: "#184B72",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.959 44.5601L428.039 290.56L585.479 288.92L473.959 44.5601Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.24 116.72L428.04 290.56L473.96 44.5601L272.24 116.72Z",
    fill: "#2C80D9",
    stroke: "#2C80D9",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.48 288.92L660.92 423.4L749.48 298.76L585.48 288.92Z",
    fill: "#1B6CB2",
    stroke: "#1B6CB2",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.641 433.24L660.921 423.4L585.481 288.92L534.641 433.24Z",
    fill: "#1B6CB2",
    stroke: "#1B6CB2",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.48 298.76L938.08 415.2L998.76 218.4L749.48 298.76Z",
    fill: "#2073BF",
    stroke: "#2073BF",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.92 423.4L788.84 441.44L749.48 298.76L660.92 423.4Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.76 218.4L1172.6 192.16L1134.88 110.16L998.76 218.4Z",
    fill: "#17527E",
    stroke: "#17527E",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.04 366L1172.6 192.16L998.76 218.4L1084.04 366Z",
    fill: "#1865A5",
    stroke: "#1865A5",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.88 110.16L1292.32 -32.5201L1143.08 -65.3201L1134.88 110.16Z",
    fill: "#17527E",
    stroke: "#17527E",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.84 441.44L938.08 415.2L749.48 298.76L788.84 441.44Z",
    fill: "#184B72",
    stroke: "#184B72",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.24 -48.9199V116.72L473.96 44.5601L272.24 -48.9199Z",
    fill: "#1865A5",
    stroke: "#1865A5",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.039 290.56L534.639 433.24L585.479 288.92L428.039 290.56Z",
    fill: "#3486E7",
    stroke: "#3486E7",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.281 346.32L534.641 433.24L428.041 290.56L331.281 346.32Z",
    fill: "#184B72",
    stroke: "#184B72",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.08 415.2L1084.04 366L998.76 218.4L938.08 415.2Z",
    fill: "#184B72",
    stroke: "#184B72",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.24 116.72L314.88 280.72L428.04 290.56L272.24 116.72Z",
    fill: "#3D8DF4",
    stroke: "#3D8DF4",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48 -24.3201L231.24 142.96L272.24 116.72L175.48 -24.3201Z",
    fill: "#1865A5",
    stroke: "#1865A5",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.24 116.72L231.24 142.96L314.88 280.72L272.24 116.72Z",
    fill: "#3486E7",
    stroke: "#3486E7",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.48 59.32L1292.32 -32.52L1134.88 110.16L1364.48 59.32Z",
    fill: "#2073BF",
    stroke: "#2073BF",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.48 59.3201L1134.88 110.16L1172.6 192.16L1364.48 59.3201Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.08 415.2L985.64 530L1084.04 366L938.08 415.2Z",
    fill: "#175F98",
    stroke: "#175F98",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.801 282.36L331.281 346.32L314.881 280.72L196.801 282.36Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.881 280.72L331.281 346.32L428.041 290.56L314.881 280.72Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.24 -48.9199L175.48 -24.3199L272.24 116.72V-48.9199Z",
    fill: "#175F98",
    stroke: "#175F98",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.64 372.56L1280.84 261.04L1084.04 366L1354.64 372.56Z",
    fill: "#2073BF",
    stroke: "#2073BF",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.04 366L1280.84 261.04L1172.6 192.16L1084.04 366Z",
    fill: "#3D8DF4",
    stroke: "#3D8DF4",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.84 261.04L1364.48 59.3198L1172.6 192.16L1280.84 261.04Z",
    fill: "#184B72",
    stroke: "#184B72",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.241 142.96L196.801 282.36L314.881 280.72L231.241 142.96Z",
    fill: "#3486E7",
    stroke: "#3486E7",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.281 346.32L406.721 530L534.641 433.24L331.281 346.32Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 288.92L196.8 282.36L231.24 142.96L0 288.92Z",
    fill: "#2679CC",
    stroke: "#2679CC",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.719 384.04L406.719 530L331.279 346.32L201.719 384.04Z",
    fill: "#1865A5",
    stroke: "#1865A5",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48 -24.3201L0 44.5599L231.24 142.96L175.48 -24.3201Z",
    fill: "#1B6CB2",
    stroke: "#1B6CB2",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.641 530H1138.16L1084.04 366L985.641 530Z",
    fill: "#17527E",
    stroke: "#17527E",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 349.6L201.72 384.04L196.8 282.36L0 349.6Z",
    fill: "#2679CC",
    stroke: "#2679CC",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.801 282.36L201.721 384.04L331.281 346.32L196.801 282.36Z",
    fill: "#175F98",
    stroke: "#175F98",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 205.28V121.64L1364.48 59.3198L1476 205.28Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.68 530L1354.64 372.56L1084.04 366L1249.68 530Z",
    fill: "#17527E",
    stroke: "#17527E",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.48 59.3201L1476 -45.6399L1292.32 -32.5199L1364.48 59.3201Z",
    fill: "#3486E7",
    stroke: "#3486E7",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 121.64V-45.6401L1364.48 59.3199L1476 121.64Z",
    fill: "#17527E",
    stroke: "#17527E",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 205.28L1364.48 59.3201L1280.84 261.04L1476 205.28Z",
    fill: "#175F98",
    stroke: "#175F98",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.16 530H1249.68L1084.04 366L1138.16 530Z",
    fill: "#1865A5",
    stroke: "#1865A5",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -47.28V44.56L175.48 -24.32L0 -47.28Z",
    fill: "#175F98",
    stroke: "#175F98",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 452.92V205.28L1354.64 372.56L1476 452.92Z",
    fill: "#2073BF",
    stroke: "#2073BF",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.64 372.56L1476 205.28L1280.84 261.04L1354.64 372.56Z",
    fill: "#2679CC",
    stroke: "#2679CC",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 44.5601V288.92L231.24 142.96L0 44.5601Z",
    fill: "#1865A5",
    stroke: "#1865A5",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.72 384.04L134.48 530H406.72L201.72 384.04Z",
    fill: "#2C80D9",
    stroke: "#2C80D9",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 349.6L134.48 530L201.72 384.04L0 349.6Z",
    fill: "#3D8DF4",
    stroke: "#3D8DF4",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 288.92V349.6L196.8 282.36L0 288.92Z",
    fill: "#16588B",
    stroke: "#16588B",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 530V452.92L1354.64 372.56L1476 530Z",
    fill: "#1B6CB2",
    stroke: "#1B6CB2",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.68 530H1476L1354.64 372.56L1249.68 530Z",
    fill: "#2073BF",
    stroke: "#2073BF",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 349.6V530H134.48L0 349.6Z",
    fill: "#3486E7",
    stroke: "#3486E7",
    strokeLinejoin: "bevel"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_385_6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376 69.004C1362.74 69.004 1352 79.7508 1352 93C1352 79.7427 1341.25 69.004 1328 69.004C1341.26 69.004 1352 58.2573 1352 45C1352 58.2573 1362.74 69.004 1376 69.004Z",
    fill: "black",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 104.002C1335.54 104.002 1329.5 110.271 1329.5 118C1329.5 110.267 1323.45 104.002 1316 104.002C1323.46 104.002 1329.5 97.7334 1329.5 90C1329.5 97.7334 1335.54 104.002 1343 104.002Z",
    fill: "black",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379 117.002C1371.27 117.002 1365 123.271 1365 131C1365 123.267 1358.73 117.002 1351 117.002C1358.73 117.002 1365 110.733 1365 103C1365 110.733 1371.27 117.002 1379 117.002Z",
    fill: "black",
    fillOpacity: 0.08
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1368 63.004C1354.74 63.004 1344 73.7508 1344 87C1344 73.7427 1333.25 63.004 1320 63.004C1333.26 63.004 1344 52.2573 1344 39C1344 52.2573 1354.74 63.004 1368 63.004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1335 98.0024C1327.54 98.0024 1321.5 104.271 1321.5 112C1321.5 104.267 1315.45 98.0024 1308 98.0024C1315.46 98.0024 1321.5 91.7334 1321.5 84C1321.5 91.7334 1327.54 98.0024 1335 98.0024Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1371 111.002C1363.27 111.002 1357 117.271 1357 125C1357 117.267 1350.73 111.002 1343 111.002C1350.73 111.002 1357 104.733 1357 97C1357 104.733 1363.27 111.002 1371 111.002Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_385_6667",
    x: 1310,
    y: 39,
    width: 75,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_385_6667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_6667",
    x1: 738,
    y1: 0,
    x2: 738,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5671F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_385_6667",
    x1: 738,
    y1: 1,
    x2: 738,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5671F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183ADC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.868384266b8c4f7bb390d374dbde21ed.svg";
export { ForwardRef as ReactComponent };